import {ABOUT, CART, ORDER, RESTAURANT} from "../constants/routes.constants";
import {MenuEntryId} from "./menu.helper.types";
import {OrderId} from "./order.helper.types";

export const getRestaurantRoute = (entryIdToExpand?:MenuEntryId): string => {
	return RESTAURANT
		.replace(':entryIdToExpand?', entryIdToExpand?.toString() || '');
}

export const getAboutRoute = (): string => {
	return ABOUT;
}

export const getCartRoute = (): string => {
	return CART;
}

export const getOrderRoute = (orderId: OrderId, isReview = false): string => {
	return ORDER
		.replace(':orderId', orderId.toString())
		.replace(':isReview?', isReview ? 'review':'');
}

export const getRouteByPathname = (pathname): string => {
	if (pathname === ABOUT) {
		return ABOUT;
	}

	if (pathname === CART) {
		return CART;
	}

	if (pathname.includes('/restaurant')) {
		return RESTAURANT;
	}

	if (pathname.includes('/order')) {
		return ORDER;
	}

	return RESTAURANT;
}
